const stock_bot = {
  title: 'Stock Bot',
  panoramica: 'Overview',
  dettagli: 'Details',
  data_until_today: 'Current values',
  data_until_end_of_last_year: 'Previous year',
  category_totals_title: 'Value distribution by category',
  total: 'Total',
  deposit_category_table_title: 'Categories by warehouse',
  category_table_title: 'Category totals',
  deposit_bar_chart_title: 'Value by warehouse',
  warehouse: 'Warehouse',
  category: 'Category',
  details_table_title: 'Item details',
  search_placeholder: 'Search...',
  col_mag_cod: 'Warehouse code',
  col_mag_sigla: 'Warehouse acronym',
  col_codmag: 'Stock code',
  col_codice_articolo: 'Item code',
  col_descrizione: 'Description',
  col_clamer: 'Clamer',
  col_famiglia: 'Family',
  col_settore: 'Sector',
  col_giacenza: 'Stock',
  col_valore: 'Value',
  col_ultven_locale: 'Last local sale',
  col_primo_arr: 'First arrival',
  col_cpa_anprec: 'CPA prev. year',
  col_ultven_globale: 'Last global sale',
  col_mesi_copertura: 'Coverage months',
  col_categoria: 'Category',
  col_valore_netto: 'Net value',
  analyze_selected: 'Analyze selected',
  analysis: 'Analysis',
  analysis_warehouse: 'Warehouse',
  analysis_stock: 'Stock',
  analysis_value: 'Value',
  analysis_cmp: 'CMP',
  analysis_pieces_short: 'pcs',
  analysis_months_short: 'm',
  analysis_cpa_global: 'Global CPA {year} (net returns)',
  analysis_thresholds: 'Thresholds',
  vivo_72_title: 'Why VIVO_72:',
  vivo_72_intro: 'this row represents the surplus beyond 72 months of coverage — band beyond 72 months.',
  vivo_72_coverage_pre: 'Global item coverage is',
  vivo_72_coverage_suf: 'months (global stock / global monthly CPA).',
  vivo_72_local_quota_pre: 'The row stock',
  vivo_72_local_quota_suf: 'corresponds to the warehouse VIVO_72 share (see below).',
  vivo_72_breakdown_global: '1) Global item split (sum across all warehouses classified VIVO):',
  vivo_72_breakdown_global_total: 'Total VIVO stock',
  vivo_72_splits_in: 'split into:',
  vivo_72_breakdown_local: '2) Share in this warehouse (global shares distributed proportionally to qta_netta_loc / giac_residuo_glob):',
  vivo_72_formula_hint: 'Global shares are computed from total VIVO stock and CPA: q_ok = LEAST(stock, 4×cpa), q_48 = LEAST(MAX(stock − 4×cpa, 0), 2×cpa), q_72 = MAX(stock − 6×cpa, 0).',
  vivo_48_title: 'Why VIVO_48:',
  vivo_48_intro: 'this row represents the stock share covering the 48–72 month band (24-month band after the VIVO_OK share) — band 48–72 months.',
  vivo_48_local_quota_suf: 'corresponds to the warehouse VIVO_48 share (see below).',
  vivo_ok_title: 'Why VIVO_OK:',
  vivo_ok_intro: 'this row represents the stock share needed to cover the first 48 months of consumption — band 0–48 months.',
  vivo_ok_coverage_pre: 'Global item coverage is',
  vivo_ok_coverage_suf: 'months (global stock / global monthly CPA).',
  vivo_ok_local_quota_pre: 'The row stock',
  vivo_ok_local_quota_suf: 'corresponds to the warehouse VIVO_OK share (see below).',
  super_new_title: 'Why SUPER_NEW:',
  super_new_intro_pre: "the item's first in-house trace is dated",
  super_new_intro_mid: ', after the threshold of',
  super_new_intro_suf: '(last 24 months).',
  super_new_formula_a: 'is the oldest date among:',
  super_new_formula_b: '(supplier delivery note)',
  super_new_formula_c: 'excluding 1970 sentinels',
  super_new_formula_d: '(first sale)',
  super_new_formula_e: 'excluding 1970 sentinels. If even one of these is earlier than the threshold, the item is NOT SUPER_NEW.',
  super_new_first_arr_pre: 'First arrival registered in delivery note:',
  super_new_global_note: 'GLOBAL category: applies to all warehouses where the item is present.',
}

export default stock_bot
